export default __webpack_public_path__ + "static/media/gate-io.6ee2b5c9.svg";